export default "__VITE_ASSET__CqUlAmxz__"